import React, { useState } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { ReactComponent as ShareWhite } from "assets/icons/share-white.svg";

import ReceiptSharingDrawer from "./drawer";

const ReceiptSharing = ({
  className = "",
  shareWithImageText = {},
  onDownloadImage,
  onShareImage,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleToggleDrawer = (visible = false) => setOpen(visible);

  return (
    <div
      className={`p-5 w-full border-t z-[99] bg-white border-gray--7 bottom-0 max-w-3xl ${className}`}
    >
      <Button
        block
        className={`primary-button-large min-h-[46px] justify-center items-center`}
        onClick={() => handleToggleDrawer(true)}
      >
        <ShareWhite className="ml-1 [&>path]:fill-white " />
        {t("share")}
      </Button>
      <ReceiptSharingDrawer
        open={open}
        shareWithImageText={shareWithImageText}
        onDownloadImage={onDownloadImage}
        onShareImage={onShareImage}
        onClose={() => handleToggleDrawer()}
      />
    </div>
  );
};

export default ReceiptSharing;
